<template>
  <div class="search row">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12"><p class="label">{{ $t("message.search_engine") }}</p></div>
      </div>
      <div class="form-row">
        <div class="col-md-12">
          <input v-model.lazy="query" v-debounce="delay" @click="searchModeOn" @input="searchingOn" type="text" class="form-control" :placeholder="$t('message.search_input_placeholder')">
          <transition name="slide-fade">
            <div class="table-box" v-if="searchMode" v-click-outside="searchModeOff">
              <table v-if="searching"><tr class="searching"><td>{{ $t("message.searching") }}...</td></tr></table>
              <table v-else>
                <tr v-for="category in filtered_categories" @click="searchModeOff">
                  <td v-scroll-to="`#`+to_slug(category.name)" class="category">{{category.name}}</td>
                </tr>
                <tr class="separator" v-if="show_separator"><td colspan=3><hr /></td></tr>
                <tr class="no-results" v-if="show_no_results"><td colspan=3>{{ $t("message.no_results") }}</td></tr>
                <tr v-for="product in filtered_products" @click="searchModeOff">
                  <td v-scroll-to="`#`+to_slug(product.data.code)" class="product"><strong>{{product.data.code}}</strong> - {{product.data.name}} <span><Price :product=product /></span></td>
                </tr>
              </table>
            </div>
          </transition>
        </div>
      </div>
      <div>
        <transition name="bounce">
          <button class="btn btn-danger x" v-if="searchMode" @click="searchModeOff;clearInput"><i class="fa fa-times"></i></button>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import debounce from 'v-debounce'
import { mapGetters } from 'vuex'

import ClickOutside from 'vue-click-outside'
import { helpers } from '../mixins/helpers'
import Price from '../Product/Price.vue'



export default {
  mixins: [helpers],
  components: {
    Price
  },
  name: 'Search',
  data () {
    return {
      msg: 'Search',
      query: '',
      searchMode: false,
      delay: 300,
      term: '',
      searching: false,
      options: {
        shouldSort: true,
        threshold: 0.5,
        location: 5,
        distance: 30,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: [
          "data.code",
          "data.name"
        ]
      }
    }
  },
  methods: {
    clearInput() {
      this.query = '';
    },
    searchModeOff() {
      this.clearInput();
      this.searchMode = false;
    },
    searchModeOn() {
      if(this.query != '') {
        this.searchMode = true;
      }
    },
    searchingOn() {
      this.searching = true;
    },
  },
  computed: {
     ...mapGetters('pricelist', ['listType']),
    filtered_categories() {
      return this.$store.getters['pricelist/filtered_categories'];
    },
    filtered_categories_count() {
      return this.$store.getters['pricelist/filtered_categories_count'];
    },
    filtered_products() {
      return this.$store.getters['pricelist/filtered_products'];
    },
    filtered_products_count() {
      return this.$store.getters['pricelist/filtered_products_count'];
    },
    category_id() {
      return 1;
    },
    show_separator() {
      return this.filtered_categories.length && this.filtered_products.length;
    },
    show_no_results() {
      return !this.filtered_categories.length && !this.filtered_products.length;
    },
  },
  watch: {
    query() {
      if(this.query !== '') {
        this.$store.commit('search/searchModeOn');
        this.searchMode = this.$store.getters['search/getMode'];
      }
      else {
        this.$store.commit('search/searchModeOff');
        this.searchMode = this.$store.getters['search/getMode'];
      }
      this.$store.dispatch('pricelist/loadFilteredCategoriesAsync',{query: this.query, 'company': this.listType}).then(() => {
        this.$store.dispatch('pricelist/load_products_filtered', {query: this.query, options: this.options, 'company': this.listType});
        this.$store.commit('search/setInputValue',{'value':this.query, 'company': this.listType});
        this.searching = false;
      });
    }
  },
  directives: {
    debounce, ClickOutside
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.Price {
  display: inline;
  color: inherit;
}
.search {
  background: #f1f1f1;
  padding: 0px 0px 30px;
  position: relative;
  @media(min-width: 576px) {
    padding: 10px 30px;
  }
  .label {
    font-size: .8em;
    text-align: center;
    padding: 15px 0 0;
    color: #5f5f5f;
    @media(min-width: 576px) {
      font-size: 1em;
    }
  }
  input {
    font-family: inherit;
    padding: 15px 7.5px;
    border-radius: 0;
    font-size: .9em;
    height: auto;
    @media(min-width: 576px) {
      padding: 18px 15px;
      font-size: .8em;
    }
    &::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
      font-style: italic;
      font-size: .8em;
      opacity: 1; /* Firefox */
      @media(min-width: 576px) {
        font-size: 1em;
      }
    }
    &:-ms-input-placeholder { /* Internet Explorer 10-11 */
      font-style: italic;
      @media(min-width: 576px) {
        font-size: 1em;
      }
    }
    &::-ms-input-placeholder { /* Microsoft Edge */
      font-style: italic;
      @media(min-width: 576px) {
        font-size: 1em;
      }
    }
  }
  h3 {
    color: #7e7e7e;
  }
  .form-row {
    position: relative;
    &:focus {
      border-color: inherit;
      -webkit-box-shadow: none;
      box-shadow: none;
      border: 1px solid #23497f;
    }
  }
  .x {
    height: 32px;
    line-height: 6px;
    position: absolute;
    right: 28px;
    top: 70px;
    i {
      font-size: .6em;
    }
    @media(min-width: 576px) {
      height: 32px;
      line-height: 6px;
      position: absolute;
      right: 22px;
      top: 77px;
    }
  }
}
.table-box {
  margin: auto;
  overflow: hidden;
  position: absolute;
  top: 59px;
  left: 5px;
  right: 5px;
  background: white;
  border: 1px solid #ced4da;
  border-top: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  z-index: 900;
  @media(min-width: 576px) {
    top: 62px;
  }
  @media(min-width: 768px) {
    top: 62px;
    left: 5px;
    right: 5px;
  }
  table {
    width: 100%;
    overflow: hidden;
    display: block;
    color: #5f5f5f;
    font-weight: 300;
    &:hover {
      -webkit-transition: all 180ms ease;
      -moz-transition: all 180ms ease;
      -ms-transition: all 180ms ease;
      -o-transition: all 180ms ease;
      transition: all 180ms ease;
      color: lighten(#5f5f5f,20%);
    }
    @media(min-width: 768px) {
      display: table;
    }
    tr {
      display: block;
      width: 100%;
      border-bottom: 1px solid #ddd;
      @media(min-width: 768px) {
        display: table-row;
      }
      &:hover:not(.no-results):not(.searching) {
        -webkit-transition: all 180ms ease;
        -moz-transition: all 180ms ease;
        -ms-transition: all 180ms ease;
        -o-transition: all 180ms ease;
        transition: all 180ms ease;
        color: darken(#5f5f5f,30%);
        font-weight: 700;
        cursor: pointer;
      }
      &.no-results {
        td {
          color: #969696 !important;
        }
      }
      &.category {
        font-size: .3em;
        @media(min-width: 768px) {
          font-size: .8em;
        }
      }
      td {
        display: block;
        width: 100%;
        border: 0;
        margin: 0;
        overflow: hidden;
        padding: 10px;
        font-size: .7em;
        @media(min-width: 768px) {
          display: table-cell;
          padding: 2px 7.5px;
          font-size: .8em;
        }
      }
    }
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.fade-slow-enter-active, .fade-slow-leave-active {
  transition: opacity .25s;
}
.fade-slow-enter, .fade-slow-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .35s ease;
}
.slide-fade-leave-active {
  transition: all .35s cubic-bezier(.2, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-10px);
  opacity: 0;
}
/* Bounce */
.bounce-enter-active {
  animation: bounce-in .35s;
}
.bounce-leave-active {
  animation: bounce-in .35s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Search/Search.vue